// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-sale-location {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: var(--chakra-sizes-full);
  height: var(--chakra-sizes-full);
  padding: 0;
  gap: var(--chakra-sizes-0\\.5);
  border: var(--chakra-borders-md);
  border-color: transparent;
  border-radius: var(--chakra-radii-md);
  box-shadow: var(--chakra-shadows-sm);
  font: inherit;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  appearance: none;
  -webkit-appearance: none;
  user-select: none;
  touch-action: manipulation;
}
.btn-sale-location:hover {
  filter: brightness(1.1);
}
.dark .btn-sale-location:hover {
  filter: brightness(0.9);
}
.btn-sale-location:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}
.btn-sale-location-badges {
  position: absolute;
  top: -0.65rem;
  right: -0.65rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--chakra-sizes-1);
}
.btn-sale-location-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--chakra-sizes-6);
  height: var(--chakra-sizes-6);
  border-radius: var(--chakra-radii-full);
  color: var(--chakra-colors-white);
}
.btn-sale-location-badge-success {
  background: var(--chakra-colors-success);
}
.btn-sale-location-badge-info {
  background: var(--chakra-colors-blue-500);
}
.btn-sale-location-badge-error {
  background: var(--chakra-colors-error);
}
.btn-sale-location-badge-icon {
  width: var(--chakra-sizes-4);
  height: var(--chakra-sizes-4);
}
.btn-sale-location-content {
  width: var(--chakra-sizes-full);
  overflow: hidden;
  text-align: center;
}
.btn-sale-location-title {
  display: block;
  font-size: var(--chakra-font-sizes-lg);
  font-weight: var(--chakra-font-weights-bold);
}
.btn-sale-location-amount,
.btn-sale-location-companions {
  display: flex;
  justify-content: center;
  gap: var(--chakra-sizes-1);
  font-size: var(--chakra-font-sizes-xs);
  font-weight: var(--chakra-font-weights-semibold);
}
.btn-sale-location-companions {
  align-items: center;
  width: var(--chakra-sizes-full);
}
.btn-sale-location-amount-refund {
  color: var(--chakra-colors-blue-500);
}
.btn-sale-location-companions-icon {
  width: var(--chakra-sizes-3);
  height: var(--chakra-sizes-3);
}
.btn-sale-location-amount-icon {
  width: var(--chakra-sizes-4);
  height: var(--chakra-sizes-4);
}
@media (min-width: 48rem) {
  .btn-sale-location-title {
    font-size: var(--chakra-font-sizes-xl);
  }
}
.btn-sale-location-inactive,
.btn-sale-location-refund {
  animation: btn-sale-location-blink 1.5s infinite both;
}
.btn-sale-location-inactive {
  --blink-border-color: var(--chakra-colors-error);
}
.btn-sale-location-refund {
  --blink-border-color: var(--chakra-colors-blue-500);
}
@keyframes btn-sale-location-blink {
  0%,
  100% {
    border-width: 2px;
  }
  50% {
    border-color: var(--blink-border-color);
    border-width: 2px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pos/css/sale-location-button.less"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,+BAA+B;EAC/B,gCAAgC;EAChC,UAAU;EACV,6BAA6B;EAC7B,gCAAgC;EAChC,yBAAyB;EACzB,qCAAqC;EACrC,oCAAoC;EACpC,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;EAC7B,uCAAuC;EACvC,iCAAiC;AACnC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,sCAAsC;AACxC;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,sCAAsC;EACtC,4CAA4C;AAC9C;AACA;;EAEE,aAAa;EACb,uBAAuB;EACvB,0BAA0B;EAC1B,sCAAsC;EACtC,gDAAgD;AAClD;AACA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE;IACE,sCAAsC;EACxC;AACF;AACA;;EAEE,qDAAqD;AACvD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,mDAAmD;AACrD;AACA;EACE;;IAEE,iBAAiB;EACnB;EACA;IACE,uCAAuC;IACvC,iBAAiB;EACnB;AACF","sourcesContent":[".btn-sale-location {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  width: var(--chakra-sizes-full);\n  height: var(--chakra-sizes-full);\n  padding: 0;\n  gap: var(--chakra-sizes-0\\.5);\n  border: var(--chakra-borders-md);\n  border-color: transparent;\n  border-radius: var(--chakra-radii-md);\n  box-shadow: var(--chakra-shadows-sm);\n  font: inherit;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  appearance: none;\n  -webkit-appearance: none;\n  user-select: none;\n  touch-action: manipulation;\n}\n.btn-sale-location:hover {\n  filter: brightness(1.1);\n}\n.dark .btn-sale-location:hover {\n  filter: brightness(0.9);\n}\n.btn-sale-location:disabled {\n  cursor: not-allowed;\n  opacity: 0.4;\n}\n.btn-sale-location-badges {\n  position: absolute;\n  top: -0.65rem;\n  right: -0.65rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--chakra-sizes-1);\n}\n.btn-sale-location-badge {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: var(--chakra-sizes-6);\n  height: var(--chakra-sizes-6);\n  border-radius: var(--chakra-radii-full);\n  color: var(--chakra-colors-white);\n}\n.btn-sale-location-badge-success {\n  background: var(--chakra-colors-success);\n}\n.btn-sale-location-badge-info {\n  background: var(--chakra-colors-blue-500);\n}\n.btn-sale-location-badge-error {\n  background: var(--chakra-colors-error);\n}\n.btn-sale-location-badge-icon {\n  width: var(--chakra-sizes-4);\n  height: var(--chakra-sizes-4);\n}\n.btn-sale-location-content {\n  width: var(--chakra-sizes-full);\n  overflow: hidden;\n  text-align: center;\n}\n.btn-sale-location-title {\n  display: block;\n  font-size: var(--chakra-font-sizes-lg);\n  font-weight: var(--chakra-font-weights-bold);\n}\n.btn-sale-location-amount,\n.btn-sale-location-companions {\n  display: flex;\n  justify-content: center;\n  gap: var(--chakra-sizes-1);\n  font-size: var(--chakra-font-sizes-xs);\n  font-weight: var(--chakra-font-weights-semibold);\n}\n.btn-sale-location-companions {\n  align-items: center;\n  width: var(--chakra-sizes-full);\n}\n.btn-sale-location-amount-refund {\n  color: var(--chakra-colors-blue-500);\n}\n.btn-sale-location-companions-icon {\n  width: var(--chakra-sizes-3);\n  height: var(--chakra-sizes-3);\n}\n.btn-sale-location-amount-icon {\n  width: var(--chakra-sizes-4);\n  height: var(--chakra-sizes-4);\n}\n@media (min-width: 48rem) {\n  .btn-sale-location-title {\n    font-size: var(--chakra-font-sizes-xl);\n  }\n}\n.btn-sale-location-inactive,\n.btn-sale-location-refund {\n  animation: btn-sale-location-blink 1.5s infinite both;\n}\n.btn-sale-location-inactive {\n  --blink-border-color: var(--chakra-colors-error);\n}\n.btn-sale-location-refund {\n  --blink-border-color: var(--chakra-colors-blue-500);\n}\n@keyframes btn-sale-location-blink {\n  0%,\n  100% {\n    border-width: 2px;\n  }\n  50% {\n    border-color: var(--blink-border-color);\n    border-width: 2px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
